// extracted by mini-css-extract-plugin
export default {"ellipsis":"ellipsis-OAAUPyGI","bounce":"bounce-qmuyZOZ1","dot":"dot-pSf4v3vK","fade":"fade-CEfGy0BA","small":"small-au6p8pBX","large":"large-q77LNGVT"};